import React from "react";
import { ArrowUpRight } from "lucide-react";
import { news } from "../mock";
import { useReveal } from "../hooks/useReveal";
import { useSettings } from "../context/SettingsContext";

export default function News() {
  const { ref, inView } = useReveal();
  const settings = useSettings();
  const items = settings?.newsItems?.length
    ? settings.newsItems.map((n, i) => ({ ...n, id: i, img: n.image }))
    : news;
  return (
    <section id="news" className="relative py-24 bg-[#0d0d0f]">
      <div className="max-w-7xl mx-auto px-5">
        <div ref={ref} className={`reveal ${inView ? "in-view" : ""} flex items-end justify-between`}>
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-[2px] w-10 bg-gold" />
              <span className="section-label text-gold text-xs">Club Updates</span>
            </div>
            <h2 className="display-font uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Latest <span className="text-gold">news.</span>
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-14">
          {items.map((n) => (
            <article
              key={n.id}
              className="group rounded-lg overflow-hidden border border-white/10 bg-card hover:border-gold/50 transition-colors"
            >
              <div className="relative h-52 overflow-hidden">
                <img src={n.img} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <span className="absolute top-4 left-4 cond-font uppercase text-[11px] tracking-widest text-black bg-gold px-3 py-1 rounded-sm">
                  {n.category}
                </span>
              </div>
              <div className="p-6">
                <div className="cond-font uppercase tracking-widest text-xs text-white/40">{n.date}</div>
                <h3 className="cond-font text-lg text-white mt-2 leading-snug group-hover:text-gold transition-colors">
                  {n.title}
                </h3>
                <p className="text-white/55 font-light text-sm mt-3 leading-relaxed">{n.excerpt}</p>
                <div className="inline-flex items-center gap-1 mt-4 cond-font uppercase tracking-widest text-xs text-gold">
                  Read More <ArrowUpRight size={14} />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
